export default "__VITE_ASSET__C01J0KiD__"